import { useState } from "react";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";
import AddCandidateModal from "@/pages/candidates/components/Add_Candidate_Modal";

const EmptyState = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalVisibility = () => {
    setIsModalVisible(!isModalVisible);
  };

  return (
    <div className="flex flex-col items-center justify-center rounded-lg p-8 mt-6">
      <WebIcon
        icon="CandidatesHover"
        size="large"
        className="mb-6 w-[100px] h-[100px]"
      />
      <h2 className="heading-large whitespace-nowrap font-bold text-lighterGrey mb-4">
        Candidate Empty
      </h2>
      <p className="text-bold-x font-normal text-lighterGrey mb-8">
        There&apos;s nothing to show here
      </p>
      <Button
        text="SET UP A CANDIDATE"
        color="primary"
        className="w-full px-6 py-3 text-white font-medium"
        customBgColor="primary"
        customTextColor="white"
        onClick={handleModalVisibility}
      />
      <AddCandidateModal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      />
    </div>
  );
};

export default EmptyState;
